// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data embedded as JSON in the section
    const product = JSON.parse(section.querySelector(".productV24JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file
    let activeVariant = JSON.parse(section.querySelector(".productV24VariantJSON").textContent);

    // map of variant id to its maltertech.ongoing_price metafield (dollars, null when unset)
    const variantIDtoOngoingPrice = JSON.parse(section.querySelector(".productV24VariantIDtoOngoingPriceJSON").textContent);

    // map of variant id to its custom.dosage_with_text metafield, the same per dose copy the selling card shows
    const variantIDtoDose = JSON.parse(section.querySelector(".productV24VariantIDtoDoseJSON").textContent);

    // map of variant id to its maltertech.one_time_purchase_swap variant id (null when unset)
    const variantSwapMap = JSON.parse(section.querySelector(".productV24VariantSwapJSON").textContent);

    // price test duplicates subscribe through their own subscription product (null when the section doesn't set one)
    const subscriptionProduct = JSON.parse(section.querySelector(".productV24SubscriptionJSON").textContent);

    /************
     Product Swiper
     ************/

    let thumbs = new Swiper(section.querySelector(".productV24VisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 4
    });


    // setup product swiper
    const productV24Swiper = new Swiper(section.querySelector(".productV24VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: section.querySelector('.productV24VisualSwiperNext'),
            prevEl: section.querySelector('.productV24VisualSwiperPrev'),
        },
        thumbs: {
            swiper: thumbs
        },
        on: {
            slideChange: function () {
                // pause all videos
                section.querySelectorAll(".productV24VisualSwiperSlide video")?.forEach(element => {
                    element.pause();
                });
            }
        }
    });


    // play video on slide play click
    section.querySelectorAll(".productV24VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV24VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV24VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // setup Dropdowns
    section.querySelectorAll(".productV24InfoDropdownTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Product Variants
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input").forEach(function (element) {
        element.addEventListener("change", function () {

            // sync the bulk order buttons
            if (element.value === 'bulk') {
                section.querySelectorAll(`input[value='bulk']`).forEach(input => {
                    input.checked = true;
                });
            }

            // if bulk is selected for the size but not selling, switch to subscription
            if (!section.querySelector(`.productV24OptionItemValuesLabelInput[value='bulk']`)?.checked && section.querySelector(`.productV24SellingLabelInput[value='bulk']`)?.checked) {
                section.querySelector(`.productV24SellingLabelInput[value='sub']`).checked = true;
            }
            // if bulk is selected for the selling but not size, switch to 4 tins
            if (section.querySelector(`.productV24OptionItemValuesLabelInput[value='bulk']`)?.checked && !section.querySelector(`.productV24SellingLabelInput[value='bulk']`)?.checked) {
                section.querySelector(`.productV24OptionItemValuesLabelInput[value='4']`).checked = true;
            }

            updateProduct();

        });
    })

    // update active variant
    function updateProduct() {
        let sellingPlanExists = section.querySelector(".productV24Selling") || false;


        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV24OptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        const isOOS = section.querySelector('.productV24ATC').classList.contains('oos');


        if (!section.querySelector(`.productV24OptionItemValuesLabelInput[value='bulk']`)?.checked) {
            section.querySelector(".productV24ATC").classList.remove('bulk');


            // check if variant wasn't found (and not bulk)
            if ((activeVariant === null || activeVariant === undefined)) {
                section.querySelector(".productV24ATC").disabled = true;
                section.querySelector(".productV24ATC").textContent = "not available";
                return;
            }

            // check if the variant is in stock
            if (activeVariant.available && isOOS) {
                section.querySelector(".productV24ATC").disabled = false;
                section.querySelector(".productV24ATC").textContent = "SOLD OUT - PRE-ORDER NOW";
            } else if (activeVariant.available) {
                section.querySelector(".productV24ATC").disabled = false;
                section.querySelector(".productV24ATC").textContent = section.querySelector(".productV24ATC").dataset.label || "add to cart";
            } else if (!activeVariant.available) {
                section.querySelector(".productV24ATC").disabled = false;
                section.querySelector(".productV24ATC").textContent = section.querySelector(".productV24ATC").dataset.label || "add to cart";
            } else {
                section.querySelector(".productV24ATC").disabled = true;
                section.querySelector(".productV24ATC").textContent = "sold out";
            }

            // update selling plan
            updateSellingPlan(sellingPlanExists, activeVariant)

            // update payments form data
            const payInstallmentsInput = section.querySelector('.productV24PaymentsInput');
            const shopifyPaymentTerms = section.querySelector('shopify-payment-terms');
            if (payInstallmentsInput) {
                payInstallmentsInput.value = activeVariant.id;
            }
            if (shopifyPaymentTerms) {
                shopifyPaymentTerms.dataset.variantId = activeVariant.id;
                shopifyPaymentTerms.setAttribute('variant-id', activeVariant.id);
            }

            // update url with variant id so the selected options are maintained on refresh
            let url = new URL(window.location.href);
            url.searchParams.set("variant", activeVariant.id);
            window.history.replaceState({}, "", url);

        }
        // if bulk
        else {
            section.querySelector(".productV24ATC").disabled = false;
            section.querySelector(".productV24ATC").classList.add('bulk');
            section.querySelector(".productV24ATC").textContent = section.querySelector(".productV24ATC").dataset.label || "add to cart";
        }


        // Update subscription bullet text for 2 or 4 tins
        // if (section.querySelector(`.productV24OptionItemValuesLabelInput[value='2']`)?.checked) {
        //     section.querySelector('.productV24SellingLabelBodyBottomWrapContentBulletsItem .size').textContent = "2";
        //     section.querySelector('.productV24SellingLabelBodyBottomWrapContentBulletsItem .servings').textContent = "32";
        //
        // } else if (section.querySelector(`.productV24OptionItemValuesLabelInput[value='4']`)?.checked) {
        //     section.querySelector('.productV24SellingLabelBodyBottomWrapContentBulletsItem .size').textContent = "4";
        //     section.querySelector('.productV24SellingLabelBodyBottomWrapContentBulletsItem .servings').textContent = "64";
        // }


    }

    /**************
     Product Selling Plan
     ***************/

    function updateSellingPlan(sellingPlanExists = true, activeVariant) {
        // Selling Plan element doesn't exist
        if (!sellingPlanExists) {
            return;
        }

        // skio:filter:start
        // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
        let activeVariantPlan = skioAllocs(activeVariant, product)[0];
        // skio:filter:end

        // reset selcet
        let optionsHTML = "";
        // loop over every selling plan allocation for this active variant

        // skio:filter:start
        // was: activeVariant.selling_plan_allocations.forEach(sellingPlanAllocation => {
        skioAllocs(activeVariant, product).forEach(sellingPlanAllocation => {
        // skio:filter:end
            // find the selling plan name since it's not in the object
            let sellingPlan = getSellingPlanById(sellingPlanAllocation.selling_plan_id);

            // create an option for the select
            // manual check for the starter kit selling plan
            if (sellingPlanAllocation.selling_plan_group_id !== "91e7beddcc2b25a88da97e3b201deec8db7b43bb") {
                optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
            }
        });
        section.querySelectorAll(".productV24SellingLabelBodyBottomWrapContentSelect").forEach((select) => {
            select.innerHTML = optionsHTML;
        })

        // save parent elements
        const once = section.querySelector(".productV24SellingLabelBody.once");
        const sub = section.querySelector(".productV24SellingLabelBody.sub");

        // update compare at price for one time and sub
        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV24SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        } else {
            once.querySelector(".productV24SellingLabelBodyPriceCompare").textContent = "";
        }

        sub.querySelector(".productV24SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        if (activeVariantPlan.compare_at_price > activeVariant.compare_at_price) {
            sub.querySelector(".productV24SellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
        }

        // update actual price
        once.querySelector(".productV24SellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
        sub.querySelector(".productV24SellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);

        once.querySelector(".productV24SellingLabelBodyPriceReal").classList.remove("sale");

        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV24SellingLabelBodyPriceReal").classList.add("sale");
        }

        // update save text
        // if one time, save $15, else save $30
        // the badge is only active when a variant has a compare at price, so it can be missing
        const saveBadge = section.querySelector('.productV24OptionItemValuesLabelBodyWrapSave.active');
        if (saveBadge && section.querySelector('.productV24SellingLabelInput:checked').value === "sub") {
            saveBadge.textContent = `Save $46`;
        } else if (saveBadge) {
            saveBadge.textContent = `Save $15`;
        }

        // update one time text
        once.querySelector(".productV24SellingLabelBodyBottomWrapContentTxt").innerHTML = `<strong>DOES NOT INCLUDE</strong> FREE SHIPPING, EXTRA 15% OFF, OR THE TRUTH OR DARE CARD DECK`;


        // update one time bullets
        if (section.querySelector('.productV24OptionItemValuesLabelInput:checked').value === "4" && section.querySelector('.productV24SellingLabelInput:checked').value === "once") {
            once.querySelector(".productV24SellingLabelBodyBottomWrapContentBullets.once")?.classList.add("active");
        }

        section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
            element.classList.remove("active");
        });
        if (section.querySelector('.productV24SellingLabelInput:checked').value === "sub") {
            section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
                element.classList.add("active");
            });
        }

        // update 4 tins icons
        if (section.querySelector('.productV24OptionItemValuesLabelInput:checked').value === "4") {
            section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        // update 2 tins icons
        if (section.querySelector('.productV24OptionItemValuesLabelInput:checked').value === "2") {
            section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV24SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        section.dispatchEvent(new CustomEvent('mainProduct:update'))

    }


    /****************
     * Product Quantity
     */

    let quantity = 1;
    updateProduct();


    /**************
     Product ATC
     ***************/

    section.querySelector(".productV24ATC").addEventListener("click", async function () {

        // check for bulk
        if (this.classList.contains("bulk")) {
            // go to /pages/bulk-order-form
            window.location.href = "/pages/bulk-order-form";

            return;
        }


        // add loading animation
        this.classList.add("loading");

        // if we're subscription on the original product, use the subscription SKUS (a subscriptionProduct is swapped below)
        let ID = activeVariant.id;
        if (!subscriptionProduct && section.querySelector(`.productV24SellingLabelInput.sub`)?.checked && section.querySelector(`.productV24OptionItemValuesLabelInput[value='2']`)?.checked) {
            ID = 44606523015305; // subscription 2 pack SKU
        } else if (!subscriptionProduct && section.querySelector(`.productV24SellingLabelInput.sub`)?.checked && section.querySelector(`.productV24OptionItemValuesLabelInput[value='4']`)?.checked) {
            ID = 44606523048073; // subscription 4 pack SKU
        } else if (!section.querySelector(`.productV24SellingLabelInput.sub`)?.checked && variantSwapMap[activeVariant.id]) {
            ID = variantSwapMap[activeVariant.id]; // one-time purchase swap from the metafield
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: ID,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productV24SellingLabelInput.sub')?.checked) {
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
            let activeVariantPlan = skioAllocs(activeVariant, product)[0];
            // skio:filter:end
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: for (let plan of activeVariant.selling_plan_allocations) {
            for (let plan of skioAllocs(activeVariant, product)) {
            // skio:filter:end
                if (plan.selling_plan_id === parseInt(section.querySelector('.productV24SellingLabelBodyBottomWrapContentSelect').value)) {
                    activeVariantPlan = plan;
                }
            }
            formData.items[0].selling_plan = activeVariantPlan.selling_plan_id

            // swap to the subscription product's matching size, it shares this product's selling plans
            if (subscriptionProduct) {
                formData.items[0].id = subscriptionProduct.variants.find(variant => variant.option1 === activeVariant.option1).id;
            }
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });


    /**
     * Given a selling plan id, find the master selling plan object
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }


    // font fix override for shopify payments (make b element normal weight)
    document.addEventListener("DOMContentLoaded", async function () {
        customElements.whenDefined("shopify-payment-terms").then(() => {
            customElements.whenDefined("shop-pay-installments-banner").then(() => {
                // the element is absent on products without installments, so bail out rather than throw
                const bannerBold = section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
                if (!bannerBold) {
                    return;
                }
                bannerBold.style = "font-weight: 400;";
            });
        });
    });

    /************
     Selling UI (folded from shared product-main.js, section-scoped)
     ************/

    // initialize the custom selling-plan select dropdown
    function initializeCustomSelect() {
        const selectElement = section.querySelector(".productV24SellingLabelBodyBottomWrapContentSelect");
        const detailsElement = section.querySelector(".customDetails");
        if (!selectElement || !detailsElement) {
            return;
        }

        const summaryElement = detailsElement.querySelector(".customDetailsTitle");
        const optionElements = detailsElement.querySelectorAll(".customOption");

        // sync the visible summary to the native select's current value
        const initialOption = selectElement.options[selectElement.selectedIndex];
        const initialValue = initialOption ? initialOption.value : "";
        if (summaryElement) {
            summaryElement.firstElementChild.textContent = initialOption ? initialOption.textContent : "";
        }

        optionElements.forEach((option, index) => {
            const value = selectElement.options[index]?.value || "";
            option.setAttribute("data-value", value);
            option.classList.toggle("selected", value === initialValue);
        });

        // clicking a custom option writes back to the native select
        optionElements.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const text = option.textContent.trim();
                selectElement.value = value;
                if (summaryElement) {
                    summaryElement.firstElementChild.textContent = text;
                }
                optionElements.forEach((opt) => opt.classList.remove("selected"));
                option.classList.add("selected");
                detailsElement.removeAttribute("open");
            });
        });
    }

    // refresh the SAVE badges from the active variant pricing
    function updateSavingsDisplay() {
        if (!activeVariant) {
            return;
        }
        const subSaveElement = section.querySelector(".productV24SellingTagDiscountSub");
        const oneTimeSaveElement = section.querySelector(".productV24SellingTagDiscountOne");
        if (!subSaveElement) {
            return;
        }
        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) {
            return;
        }
        const subTotal = activeVariant.compare_at_price ? activeVariant.compare_at_price - sellingPlanPrice : activeVariant.price - sellingPlanPrice;
        const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;
        subSaveElement.innerHTML = `SAVE ${price(subTotal, true)}`;
        if (oneTimeSaveElement) {
            if (oneTimeTotal > 0) {
                oneTimeSaveElement.innerHTML = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSaveElement.classList.remove("hidden");
            } else {
                oneTimeSaveElement.classList.add("hidden");
            }
        }

        // discount percentage off the base price (compare-at when present, otherwise regular price)
        const basePrice = activeVariant.compare_at_price || activeVariant.price;
        const discountPercent = Math.round((basePrice - sellingPlanPrice) / basePrice * 100);

        // ongoing price comes from the variant's maltertech.ongoing_price metafield (dollars), fall back to the selling plan price
        let ongoingPrice = sellingPlanPrice;
        const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
        if (ongoingPriceMetafield != null) {
            ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
        }
        const ongoingPercent = Math.round((basePrice - ongoingPrice) / basePrice * 100);

        // update bullet price - ongoing price per month plus the ongoing discount percentage
        const bulletSaveElement = section.querySelector(".productV24SellingLabelBodyBottomWrapContentBulletsItemSave");
        if (bulletSaveElement) {
            bulletSaveElement.innerHTML = `
                <span class="productV24SellingLabelBodyBottomWrapContentBulletsItemSavePrice">${price(ongoingPrice, true)}/mo after first order</span>
                <span class="productV24SellingLabelBodyBottomWrapContentBulletsItemSaveOngoing">(${ongoingPercent}% OFF ongoing)</span>
            `;
        }
    }

    // hide the one-time bottom block when it has no text
    function checkOneTimeTextVisibility() {
        const textElement = section.querySelector(".productV24SellingLabelBodyBottomWrapContentTxt");
        const bottomContentElement = section.querySelector(".productV24SellingLabelBody.once .productV24SellingLabelBodyBottom");
        if (!textElement || !bottomContentElement) {
            return;
        }
        bottomContentElement.classList.toggle("hidden", textElement.textContent.trim() === "");
    }

    // swap dosage text when a dosage option is clicked (folded from product-js.js)
    section.querySelectorAll("[data-dosage-click]").forEach((dosageOption) => {
        dosageOption.addEventListener("click", function () {
            const subItem = section.querySelector(".productV24SellingLabelBodyTopLeftDosageText");
            const oneTimeItem = section.querySelector(".productV24SellingLabelBodyTopLeftDosageText.oneTime");
            if (subItem) {
                subItem.innerHTML = dosageOption.getAttribute("data-dosage-sub");
            }
            if (oneTimeItem) {
                oneTimeItem.innerHTML = dosageOption.getAttribute("data-dosage-one-time");
            }
        });
    });

    // re-run the selling UI on load and on every product update
    function refreshSellingUI() {
        initializeCustomSelect();
        updateSavingsDisplay();
        checkOneTimeTextVisibility();
    }

    section.addEventListener("mainProduct:update", refreshSellingUI);
    refreshSellingUI();


    /**************
     Product Sticky Bar (Mobile)
     ***************/

    // the sticky bar renders outside the section element, so match it on this section's id
    const productV24Sticky = document.querySelector(`.productV24Sticky[data-product-sticky="${sectionID}"]`);
    if (productV24Sticky) {
        const productV24ATCEl = section.querySelector(".productV24ATC");
        const productV24StickySubInput = productV24Sticky.querySelector('.productV24StickyTopLeftBodyOptionsLabelInput[value="sub"]');
        const productV24StickyDose = productV24Sticky.querySelector(".productV24StickyBottomDose");
        const productV24StickyPrice = productV24Sticky.querySelector(".productV24StickyBottomPrice");
        const productV24StickyATC = productV24Sticky.querySelector(".productV24StickyTopATC");

        // several product sections can share a page, only the first bar whose section is rendered may show
        function ownsSticky() {
            const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
                const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
                return barSection && barSection.offsetParent !== null;
            });
            return owner != null && owner.dataset.productSticky === sectionID;
        }

        // show the sticky bar whenever the main ATC isn't in the viewport (above or below)
        function toggleStickyVisibility() {
            const rect = productV24ATCEl.getBoundingClientRect();
            const inView = rect.bottom > 0 && rect.top < window.innerHeight;
            productV24Sticky.classList.toggle("visible", !inView && ownsSticky());
        }

        window.addEventListener("scroll", toggleStickyVisibility, {passive: true});
        toggleStickyVisibility();

        // sync the sticky bar choice into the main selling radio so the rest of the page updates
        productV24Sticky.querySelectorAll(".productV24StickyTopLeftBodyOptionsLabelInput").forEach(input => {
            input.addEventListener("change", function () {
                const mainInput = section.querySelector(`.productV24SellingLabelInput.${this.value}`);
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event("change", {bubbles: true}));
                }
                updateProductSticky();
            });
        });

        // sticky ATC reuses the same add-to-cart flow as the main button
        productV24StickyATC.addEventListener("click", function () {
            productV24ATCEl.click();
        });

        // refresh dose visibility and price text from current variant + selling state
        function updateProductSticky() {
            const subChecked = productV24StickySubInput.checked;

            // dose price comes from the active variant's dosage metafield, hidden when it has no price
            const dosePrice = (variantIDtoDose[activeVariant.id] || "").match(/\$\d+(\.\d+)?/);
            productV24StickyDose.textContent = dosePrice ? `${dosePrice[0]}/dose` : "";

            // dose only shows for subscription
            productV24StickyDose.classList.toggle("active", subChecked && dosePrice != null);

            // price text differs by selling type
            if (subChecked) {
                // skio:filter:start
                // was: const subPrice = price(activeVariant.selling_plan_allocations[0].price * quantity, true);
                const subPrice = price(skioAllocs(activeVariant, product)[0].price * quantity, true);
                // skio:filter:end

                // ongoing price comes from the variant's maltertech.ongoing_price metafield, fall back to the selling plan price
                // skio:filter:start
                // was: let ongoingPrice = activeVariant.selling_plan_allocations[0].price;
                let ongoingPrice = skioAllocs(activeVariant, product)[0].price;
                // skio:filter:end
                const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
                if (ongoingPriceMetafield != null) {
                    ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
                }

                productV24StickyPrice.innerHTML = `<strong>${subPrice} </strong>+ FREE shipping* - <em>${price(ongoingPrice, true)}/mo after, cancel anytime</em>`;
            } else {
                const oncePrice = price(activeVariant.price * quantity, true);
                productV24StickyPrice.innerHTML = `<strong>${oncePrice}</strong> + $9.99 shipping*`;
            }
        }

        // re-render whenever the main product update event fires
        section.addEventListener("mainProduct:update", updateProductSticky);
        updateProductSticky();
    }

}());
